import React from 'react';

import { Layout } from '@components/Layout';
import { ContactBook } from '@components/utilities/Contact/ContactBook';
import { Container } from '@components/utilities/Contact/Container';
import { bookingInquiryStrings } from '@data/bookingInquiry';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${bookingInquiryStrings.consignee}一覧`,
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  body: {
    ...common.flexColumn,
    flex: 1,
  },
}));

export const Consignees: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout
      title={strings.title}
      breadcrumbs={['/utilities/Dashboard', '/utilities/Contact/Consignees/Consignees']}
    >
      <div className={classes.body}>
        <Container>
          <ContactBook
            contactType="consignee"
            largeTitle={strings.title}
            addAddressUrl={url('/utilities/Contact/Consignees/AddConsignee')}
          />
        </Container>
      </div>
    </Layout>
  );
};
